import { createGlobalStyle } from 'styled-components'

export const Reset = createGlobalStyle`
  input[type="color" i]::-webkit-color-swatch {
    border-width: 0;
  }
`
